import { render, staticRenderFns } from "./spins-popup.vue?vue&type=template&id=8167a7c6&scoped=true&"
import script from "./spins-popup.vue?vue&type=script&lang=js&"
export * from "./spins-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8167a7c6",
  null
  
)

export default component.exports